@if (hasErrors()) {
  <ul class="error-invalid">
    @for (error of getErrors(); track error) {
      <li>{{ error | translate }}</li>
    }
  </ul>
}
